import React from "react";
import * as Icons from "react-feather";

class Type {
	
	public static PHONE_CALL = new Type(1, "Phone Call", Icons.PhoneCall);
	public static TEXT = new Type(2, "Text", Icons.AlignLeft);
	public static EMAIL = new Type(3, "Email", Icons.AtSign);
	public static MEETING = new Type(4, "Meeting", Icons.Calendar);
	public static NOTE = new Type(5, "Note", Icons.Edit2);
	public static FOLLOW_UP_BOSS = new Type(6, "Follow Up Boss", Icons.RefreshCw);
	
	private constructor(
		public readonly id: number,
		public readonly label: string,
		public readonly icon: React.ComponentType<Icons.IconProps>
	) {
	}

	public get note() {
		return this === Type.NOTE;
	}

	public get phoneCall() {
		return this === Type.PHONE_CALL;
	}

	public static values(): Type[] {
		return Object.values(Type);
	}

	public static getById(id: number) {
		return this.values().find(value => value.id === id);
	}
}

export { Type as LeadNoteType };